import CustomModal from "../../../../components/Modal/CustomModal";

const DiscountList = ({ productDetail, isOpen, onRequestClose }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="상품 할인 상세 내역"
      btnClose
    >
      <h3 className="text-xl font-semibold mb-7">할인내역정보</h3>
      <ul className="flex flex-col gap-2.5 mb-6">
        <li className="flex justify-between">
          <p className="text-sm font-semibold text-neutral-500">상품금액</p>
          <p className="font-bold text-neutral-500">
            {productDetail?.sell_price.toLocaleString()}원
          </p>
        </li>
        {productDetail?.discounted_amount && (
          <li className="flex justify-between">
            <p className="text-sm font-semibold text-neutral-500">
              {productDetail?.discounted_name}
            </p>
            <p className="font-bold text-pink-600">
              {productDetail?.discounted_amount.toLocaleString()}원
            </p>
          </li>
        )}
      </ul>
      <div className="flex items-center justify-end gap-2 mb-5 ">
        <p className="text-sm font-semibold text-pink-600 text-opacity-60">
          최대할인가
        </p>
        <p className="text-pink-600">
          <b className="text-xl font-bold">
            {productDetail?.discounted_price.toLocaleString()}
          </b>
          원
        </p>
      </div>
      <p className="text-sm font-medium border-t border-neutral-600 pt-7 text-neutral-400">
        최대할인가는 포인트/카드사 등 할인 조건을 만족했을 때의 최종 할인
        가격으로, 할인 적 용 기준에 따라 실제 할인액이 표시된 금액 과 결제
        금액은 다를 수 있습니다. <br /> <br />
        신세계포인트할인/카드사 할인은 가격할인 (자동에누리)후 금액 기준으로
        적용됩니다.
      </p>
    </CustomModal>
  );
};

export default DiscountList;
